module.exports = __webpack_public_path__ + "static/media/al.bfd0a0ce.svg";